import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class MenuSettingsService {
  private readonly httpClient = inject(HttpClient);

  getMenuSettings(): Observable<boolean> {
    const url = 'api/v1/user/menu-settings/state';

    return this.httpClient.get<boolean>(environment.portalApiUrl + url);
  }

  updateMenuSettings(isMenuCollapsed: boolean): Observable<void> {
    const url = 'api/v1/user/menu-settings/state';

    return this.httpClient.post<void>(environment.portalApiUrl + url, { isCollapsed: isMenuCollapsed });
  }
}
